import { atom } from "jotai";
import { nodesAtom } from "./nodesAtom";
import { ASSET_APP_IDS } from "@zapier/canvas-constants";

const isInterfacesNode = (appId: string = "") =>
  appId.includes(ASSET_APP_IDS.INTERFACES);

export const numberOfUniqueInterfaceNodesAtom = atom((get) => {
  const nodes = get(nodesAtom);

  const interfaceNodes = nodes.filter(
    (node) =>
      isInterfacesNode(node?.data?.services?.[0]?.currentImplementation.id) &&
      node.data.projectId,
  );

  // Get unique project IDs
  const uniqueProjectIds = new Set(
    interfaceNodes.map((node) => node.data.projectId),
  );

  return uniqueProjectIds.size;
});

numberOfUniqueInterfaceNodesAtom.debugLabel =
  "numberOfUniqueInterfaceNodesAtom";
